// // **api server

export const API_HOST = "api.bpm-tripusk.uz";
export const WS_HOST = "api.bpm-tripusk.uz";
export const API_URL = `https://${API_HOST}/`;
export const IMG_URL = `https://${API_HOST}/storage/`;
export const FILE_URL = `https://${API_HOST}/storage/`;
